import {ISSUE_ATTRIBUTE_NAMES} from './issue-attribute-names';
import {TEMPLATE_FIELD_NAMES, TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES} from './issue-templates';

export const CREATE_FORM_SEPARATOR = 'CREATE_FORM_SEPARATOR';

export const CREATE_FORM_FIELD_NAMES = [
  ISSUE_ATTRIBUTE_NAMES.ISSUE_SUB_TYPE_ID,
  ISSUE_ATTRIBUTE_NAMES.STATUS,
  ISSUE_ATTRIBUTE_NAMES.TITLE,
  CREATE_FORM_SEPARATOR,
  ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
  ISSUE_ATTRIBUTE_NAMES.DUE_DATE,
  ISSUE_ATTRIBUTE_NAMES.LOCATION_ID,
  ISSUE_ATTRIBUTE_NAMES.LOCATION_DETAILS,
  ISSUE_ATTRIBUTE_NAMES.LINKED_DOCUMENTS,
  ISSUE_ATTRIBUTE_NAMES.OWNER_ID,
  ISSUE_ATTRIBUTE_NAMES.ROOT_CAUSE_ID,
  CREATE_FORM_SEPARATOR,
  ISSUE_ATTRIBUTE_NAMES.DESCRIPTION,
  ISSUE_ATTRIBUTE_NAMES.CUSTOM_ATTRIBUTES
];

export const CREATE_FORM_FIELD_NAMES_TO_KEEP_ON_CREATE_ANOTHER = [
  ISSUE_ATTRIBUTE_NAMES.STATUS,
  ISSUE_ATTRIBUTE_NAMES.ISSUE_TYPE_ID,
  ISSUE_ATTRIBUTE_NAMES.ISSUE_SUB_TYPE_ID,
  ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
  ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO_TYPE,
  ISSUE_ATTRIBUTE_NAMES.DUE_DATE,
  ISSUE_ATTRIBUTE_NAMES.LOCATION_ID,
  ISSUE_ATTRIBUTE_NAMES.OWNER_ID
];

export const CREATE_TEMPLATE_FORM_FIELD_NAMES_ORDER = [
  TEMPLATE_FIELD_NAMES.CATEGORY_ID,
  TEMPLATE_FIELD_NAMES.IS_ACTIVE,
  CREATE_FORM_SEPARATOR,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.TITLE,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.SUBTYPE_ID,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.STATUS,
  CREATE_FORM_SEPARATOR,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.ASSIGNED_TO,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.DUE_DATE,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.LOCATION_ID,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.LOCATION_DETAILS,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.OWNER_ID,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.ROOT_CAUSE_ID,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.DESCRIPTION,
  TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.CUSTOM_ATTRIBUTES
];
